module.exports = __webpack_public_path__ + "img/profile-small-light-green.8bc91e43.svg";